export default "__VITE_ASSET__3ryPlnDF__"